import { Component, OnInit } from '@angular/core';
import { SuperTransactionsService } from '../super-transactions.service';
import { AlertService } from 'src/app/_services/alert.service';
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { MenusService } from 'src/app/_services/menu.service';
import { Location } from '@angular/common';

const {defaultCurrency} = environment;


@Component({
  selector: 'app-ledger-bank',
  templateUrl: './ledger-bank.component.html',
  styleUrls: ['./ledger-bank.component.scss']
})
export class LedgerBankComponent implements OnInit {

  constructor(private superTransactionService: SuperTransactionsService, private alertService: AlertService, public formBuilder: FormBuilder, private location: Location, private router: Router, private menuService: MenusService ) { }

  searchedTransaction: any;

  transactionId: string | null = null;

  searchTransactionId: string;

  reasons: string[]

  isFormSubmitted = false;

  saveSuperTransactionForm: FormGroup;

  public permissions: string = '';

  async ngOnInit(): Promise<void> {
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }
    this.superTransactionService.getReasons().subscribe((resp: any)=> {
      var data = resp?.response?.data;
      if(data){
        this.reasons = data.map((_:any)=>_.reason);
        console.log(this.reasons);
      }
    });
    this.saveSuperTransactionForm = this.formBuilder.group({
      amountAmount: [null, [Validators.pattern(/^(\d+(\.\d{1,2})?)?$/)]],
      amountNarration: [null],
      feeAmount: [null, [Validators.pattern(/^(\d+(\.\d{1,4})?)?$/)]],
      feeNarration: [null],
      vatAmount: [null, [Validators.pattern(/^(\d+(\.\d{1,4})?)?$/)]],
      vatNarration: [null],
      reason: [null, [Validators.required]],
      remarks: [null, [Validators.required, Validators.pattern(/^[a-zA-Z0-9\s]*$/)]],
    });

    var fields = ['amount', 'fee', 'vat'];

    for(let field of fields){
      this.saveSuperTransactionForm.get(`${field}Amount`)!.valueChanges.subscribe(value => {
        const narrationControl = this.saveSuperTransactionForm.get(`${field}Narration`);
        const hasValue = value != null && value!="" && (!Array.isArray(value) || value.length > 0);
        console.log(hasValue, value);
        
        if (hasValue) {
          narrationControl!.setValidators([Validators.required, Validators.pattern(/^[a-zA-Z0-9\s]*$/)]);
        } else {
          narrationControl!.clearValidators();
        }
        narrationControl!.updateValueAndValidity();
      });
    }
  }

  searchTransaction(){
    this.searchedTransaction = null;
    if(!this.searchTransactionId){
      this.alertService.toastWarringMessageAlertWithMessage("Please enter transaction id");
      return;
    }
    this.superTransactionService.getTransactionByID(this.searchTransactionId).subscribe((resp: any) => {
      var response = resp.response;
      if(response.status!=200){
        Swal.fire(response.message, undefined, "error");
        this.transactionId = null;
      }else{
        this.transactionId = this.searchTransactionId;
        this.searchedTransaction  = response.data;
      }
    })
  }

  save(){
    this.isFormSubmitted = true;
    var amount = null;
    var fee = null;
    var vat = null;
    if (this.saveSuperTransactionForm.value.amountAmount){
      amount = {
        amount: this.saveSuperTransactionForm.value.amountAmount,
        narration: this.saveSuperTransactionForm.value.amountNarration,
      }
    }
    if (this.saveSuperTransactionForm.value.feeAmount) {
      fee = {
        amount: this.saveSuperTransactionForm.value.feeAmount,
        narration: this.saveSuperTransactionForm.value.feeNarration,
      }
    } 
    if (this.saveSuperTransactionForm.value.vatAmount) {
      vat = {
        amount: this.saveSuperTransactionForm.value.vatAmount,
        narration: this.saveSuperTransactionForm.value.vatNarration,
      }
    }
    if(this.saveSuperTransactionForm.valid){
      var request = {
        txnId: this.transactionId,
        adjustmentType: "LEDGER_AND_BANK_ADJUSTMENT",
        amount: amount,
        fee: fee,
        vat: vat,
        reason: this.saveSuperTransactionForm.value.reason,
        remarks: this.saveSuperTransactionForm.value.remarks,
        currency: defaultCurrency
      }
      this.superTransactionService.saveSuperTransaction(request).subscribe((resp : any)=>{
        var response = resp.response;
        if (response.status != 200) {
          Swal.fire(response.message, undefined, "error");
        }else{
          Swal.fire(response.message, undefined, "success");
          this.transactionId = null;
          this.searchedTransaction = null;
          this.saveSuperTransactionForm.reset();
        }
      })
    }
  }
  

}
